/**
 * 
 * @function dragScrollRegion
 * 
 * @description
 * <p>Enables scrolling with mouse drag</p>
 * 
 * @param {DOMElement} region - the DOM region that can be scrolled
 * @param {string} limit - whether to limit scrolling horizontally ('x') or vertically ('y'); must be one of 'x' or 'y'
 * @example <caption>JavaScript</caption>
 * {@lang JavaScript}
 * dragScrollRegion(dom.nav,'x');
 * dragScrollRegion(dom.nav2,'y');
*/
function dragScrollRegion(region,limit) {
	console.log("region"+region)
	var $=jQuery,x,y,top,left,down;
	if(limit) limit = limit.toLowerCase();

	$(region).addClass('dragScroll');

	$(region).mousedown(function(e){
		e.preventDefault();
		down=true;
		x=e.pageX;
		y=e.pageY;
		top=$(this).scrollTop();
		left=$(this).scrollLeft();
	});

	$(window).mousemove(function(e){
		if(down){
			var newX=e.pageX;
			var newY=e.pageY;

			// console.log(y+", "+newY+", "+top+", "+(top+(newY-y)));

			if(limit!='x') $(region).scrollTop(top-newY+y);
			if(limit!='y') $(region).scrollLeft(left-newX+x);
		}
	});

	$(window).mouseup(function(e){
		
		e.preventDefault();
		down=false;
	});
}
